import { Devtools } from "./devtools"
import { Provider } from "./provider"

export default {
  Devtools,
  Provider,
}
